import React, {useRef} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader, Button, Input} from "reactstrap";
import useWindowDimensions from "../functions/Utility";



function DeliveryRecordUpdateDeliveryAddressModal(props) {
    const {isOpen, toggle, onSubmit,  originalText} = props;
    const [originalTextToUse, setOriginalTextToUse] = React.useState('');
   // const inputEl = useRef(null);

   React.useEffect(() => {
    setOriginalTextToUse(originalText);
   }, [originalText])


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                 更改地址
            </ModalHeader>
            <ModalBody>
            <Input 
                className="mr-2 d-inline"
                type="textarea" 
                value={originalTextToUse}
                style={{height: '100px'}} 
                onChange={e => setOriginalTextToUse(e.target.value)}
                >
                </Input>
                <Button  color="danger"className="mr-2 d-inline" onClick={() => setOriginalTextToUse('')}>清空</Button>  
            </ModalBody>
            <ModalFooter>
                <Button color="info" className="mr-2 d-inline" onClick={() => onSubmit((originalTextToUse === "" ? "" :  originalTextToUse.replace(/ /g, '')))} >確定</Button>         
                <Button  color="danger"className="mr-2 d-inline" onClick={toggle}>取消</Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeliveryRecordUpdateDeliveryAddressModal
